import { connect } from 'react-redux';
import {
  loadPipeline,
  pausePipeline,
  activatePipeline,
  deletePipeline,
  setPipelineAction,
  loadFlowMetrics,
} from 'js/actions';
import {
  PAUSE_PIPELINE_REQUEST,
  ACTIVATE_PIPELINE_REQUEST,
  DELETE_PIPELINE_REQUEST,
} from 'js/constants/actionTypes';
import { isCapsuleCluster } from 'js/lib/PipelineUtils';
import { resolveFlowRunAffordance } from 'new/utils/flowRunAffordance';
import ModalPipelineAction from './ModalPipelineAction';

/**
 * flowNodeId: number | null
 * pipelineActionType: delete | pause | activate | moveToProject | null
 */
const getPipelineAction = (state) => state.pipelines?.pipelineAction;

const getFlowRunAffordance = (state, currentFlow) => {
  const source = currentFlow?.data_source_id
    ? state.entities.sources[currentFlow.data_source_id]
    : null;
  const vendorName = state.entities.vendors[source?.vendor_id]?.name;
  const connectionCategory = state.paging.metaInfoById[vendorName]?.connectionCategory;

  return resolveFlowRunAffordance({
    isCapsuleFlow: isCapsuleCluster(currentFlow),
    source,
    connectionCategory,
    status: currentFlow?.status,
  });
};

const mapStateToProps = (state, ownProps) => {
  const {
    entities: { flowNodes },
    request,
  } = state;
  const isLoading = !!(
    request[PAUSE_PIPELINE_REQUEST] ||
    request[ACTIVATE_PIPELINE_REQUEST] ||
    request[DELETE_PIPELINE_REQUEST]
  );

  const isPausing = !!request[PAUSE_PIPELINE_REQUEST];
  const isDeleting = !!request[DELETE_PIPELINE_REQUEST];
  const isActivating = !!request[ACTIVATE_PIPELINE_REQUEST];

  const pipelineAction = getPipelineAction(state);
  const currentFlow = flowNodes?.[pipelineAction?.flowNodeId];

  return {
    pipelineAction,
    flowNodes,
    flowRunAffordance: getFlowRunAffordance(state, currentFlow),
    isLoading,
    isPausing,
    isDeleting,
    isActivating,
  };
};

export default connect(mapStateToProps, {
  loadPipeline,
  pausePipeline,
  activatePipeline,
  deletePipeline,
  setPipelineAction,
  loadFlowMetrics,
})(ModalPipelineAction);
